import { v4 as uuidv4 } from "uuid";
import { mapGetters, mapActions } from "vuex";
import EventBus from "../../shared/utils/event_bus";
export default {
  data() {
    return {
      contextUuid: uuidv4(),
      connectionStatus: {
        awaitingConnection: false,
        retries: 0,
        error: false,
      },
    };
  },

  computed: {
    ...mapGetters({
      investments: "investment/InvestmentsList",
      getWebsocketIsConnected: "config/getWebsocketIsConnected",
      marketdata: "marketdata/getMarketdata",
      topics: "investment/getTopics",
    }),

    investmentTopics() {
      if (this.positionedInvestments.length) {
        let topics = [];
        this.positionedInvestments.forEach((investment) => {
          if (investment.strategy_symbol === "ANY" && investment.curr_positions.length) {
            investment.curr_positions.forEach((position) => {
              if (position.position_status !== "Zerado") {
                topics.push(this.formatTopic(position.position_symbol));
              }
            });
          } else if (typeof investment.strategy_symbol === "string") {
            topics.push(this.formatTopic(investment.strategy_symbol));
          } else if (Array.isArray(investment.strategy_symbol)) {
            investment.strategy_symbol.forEach((symbol) => {
              topics.push(this.formatTopic(symbol));
            });
          }
        });
        return Array(...new Set(topics));
      } else {
        return [];
      }
    },

    positionedInvestments() {
      let positioned_investments = this.investments.filter((investment) => {
        if (investment.status !== "STOPPED") {
          if (investment.type === "PORTFOLIO") {
            return investment.sub_strategies.some((sub_strategy) => sub_strategy.position_status !== "Zerado");
          } else if (investment.strategy_symbol === "ANY" && investment.hasOwnProperty("curr_positions")) {
            return !!investment.curr_positions.length;
          } else {
            return investment.position_status !== "Zerado";
          }
        }
      });
      return positioned_investments;
    },
  },

  methods: {
    ...mapActions({
      updateMarketdata: "investment/updateMarketdata",
      updateByMarketdata: "investment/updateByMarketdata",
      updatePositionByMarketdata: "investment/updatePositionByMarketdata",
    }),

    formatTopic(symbol) {
      return `MD.${symbol}.L1`;
    },

    formatSymbol(topic) {
      return topic.split(".")[1];
    },

    updateRunningInvestments(symbol, last_price) {
      // console.log(symbol, last_price);
      this.positionedInvestments.forEach((investment) => {
        if (investment.type === "PORTFOLIO") {
          investment.sub_strategies.forEach((sub_strategy) => {
            if (sub_strategy.position_status != "Zerado" && sub_strategy.strategy_symbol === symbol) {
              this.updateByMarketdata({
                investmentId: sub_strategy.investment_id,
                last_price: last_price ? Number(last_price) : null,
              });
            }
          });
        } else if (investment.strategy_symbol === "ANY") {
          investment.curr_positions.forEach((position, position_index) => {
            if (symbol === position.position_symbol) {
              this.updatePositionByMarketdata({
                investment_id: investment.investment_id,
                position_index,
                last_price: last_price ? Number(last_price) : null,
              });
            }
          });
        } else if (symbol === investment.strategy_symbol) {
          this.updateByMarketdata({
            investmentId: investment.investment_id,
            last_price: last_price ? Number(last_price) : null,
          }).catch((err) => {
            // console.error(err);
          });
        } else {
          return;
        }
      });
    },

    consume() {
      // console.log("[WS] Trying connection...");
      if (!this.investmentTopics) return;
      if (this.connectionStatus.retries > 5) {
        this.connectionStatus.error = true;
        console.error("[INVESTIMENTOS] Erro ao conectar ao websocket.");
        return;
      }
      if (!this.getWebsocketIsConnected) {
        if (this.isSharedWorker) this.worker.sendMessage({ type: "CHECK_CONNECTION" });
        this.connectionStatus.retries++;
        this.connectionStatus.awaitingConnection = true;
        setTimeout(() => {
          this.consume();
        }, 2000);
        return;
      }
      this.connectionStatus.awaitingConnection = false;
      this.connectionStatus.error = false;
      this.worker.sendMessage({
        type: "CONSUME",
        data: {
          uuid: this.contextUuid,
          topics: this.investmentTopics,
          type: "Investments page",
        },
      });
    },
    stopConsuming() {
      this.worker.sendMessage({
        type: "STOP_CONSUMING",
        data: this.contextUuid,
      });
    },
  },

  watch: {
    investmentTopics: {
      handler(newValue, oldValue) {
        if (oldValue.length !== newValue.length) this.consume();
      },
    },
    marketdata: {
      deep: true,
      handler(newValue) {
        this.investmentTopics?.forEach((topic) => {
          const symbol = this.formatSymbol(topic);
          this.updateRunningInvestments(symbol, newValue[symbol]);
        });
      },
    },
  },

  created() {
    window.addEventListener("beforeunload", this.stopConsuming);
    if (!this.getWebsocketIsConnected) {
      EventBus.$emit("TRY_WS_CONNECTION");
    }
  },

  mounted() {
    if (this.investmentTopics) {
      this.consume();
    }
  },

  destroyed() {
    this.stopConsuming();
    window.removeEventListener("beforeunload", this.stopConsuming);
  },
};
